import axios from 'axios';

export function getUser() {
    const user = sessionStorage.getItem('user');
    if (user === 'undefined' || !user) {
        return null;
    } else {
        return JSON.parse(user);
    }
}

export function getToken() {
    return sessionStorage.getItem('token');
}

export function setUserSession(user, token) {
    sessionStorage.setItem('user', JSON.stringify(user));
    sessionStorage.setItem('token', token);
    document.cookie = "user=" + JSON.stringify(user) + "; SameSite=None; Secure";
    document.cookie = "token=" + token + "; SameSite=None; Secure";
}

export function resetUserSession() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
}

export async function isUserLoggedIn() {
    const verifyUrl = "https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/verify"
    try {
        
        const token = getToken();
        if (!token) return false;
        
        let user = getUser()
        if (user === 'undefined' || !user) {
            return false;
        }
        
        const requestBody = {
            "user": user,
            "token": token
        }  
        
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }       
        const response = await axios.post(verifyUrl, requestBody, requestConfig)
        
        return response.status === 200;
    } catch (error) {
        if (error.response?.status === 401) {
            return false;
        }
        console.error('Login verification failed:', error);
        return false;
    }
}
    